module.exports = __webpack_public_path__ + "static/media/IMG_2831.defe4a34.JPG";